import React from 'react';
import PropTypes from 'prop-types';
import { Card, CardContent, Stack, Typography } from '@mui/material';
import { EMERGENCY_MEDICINE_SPECIALTY } from '../constants/collections';

export default function SpecialtyManager({ specialtiesMeta, drugCount }) {
  const emEntry = specialtiesMeta?.list?.find((s) => s.id === EMERGENCY_MEDICINE_SPECIALTY);

  return (
    <Card variant="outlined">
      <CardContent>
        <Typography variant="subtitle1" gutterBottom>
          Emergency Medicine
        </Typography>
        <Stack spacing={0.5}>
          <Typography variant="body2" color="text.secondary">
            Status:{' '}
            {emEntry?.discoveryCompleted ? 'Discovery completed' : 'Not discovered / draft in progress'}
          </Typography>
          <Typography variant="body2" color="text.secondary">
            Drugs in set: {drugCount}
          </Typography>
          {emEntry?.lastDiscovery && (
            <Typography variant="body2" color="text.secondary">
              Last discovery: {new Date(emEntry.lastDiscovery).toLocaleString()}
            </Typography>
          )}
        </Stack>
      </CardContent>
    </Card>
  );
}

SpecialtyManager.propTypes = {
  specialtiesMeta: PropTypes.shape({
    list: PropTypes.arrayOf(
      PropTypes.shape({
        id: PropTypes.string,
        discoveryCompleted: PropTypes.bool,
        lastDiscovery: PropTypes.string,
      })
    ),
  }),
  drugCount: PropTypes.number,
};

SpecialtyManager.defaultProps = {
  specialtiesMeta: null,
  drugCount: 0,
};
